var AplicacaoEnum = {
    COMPARTILHADA: {
        enumName: 'COMPARTILHADA',                      
        name: 'Compartilhada'
    },
    DEDICADA: {
        enumName: 'DEDICADA',  
        name: 'Dedicada'      
    },
    get(value) {        
        if(value === null)
            return AplicacaoEnum.COMPARTILHADA;

        var array = Object.values(AplicacaoEnum);
        var aplicacaoEnumFound = {};

        array.forEach(element => {
            if(element.enumName === value) {
                aplicacaoEnumFound = element;      
                return ;          
            }            
        });   
        
        return aplicacaoEnumFound;
    },
    list() {
        var array = Object.values(AplicacaoEnum);
        var aplicacaoEnumList = [];

        var aplicacao = {};        

        aplicacao.valor = 0;
        aplicacao.texto = 'Selecione';

        aplicacaoEnumList.push(aplicacao);        

        array.forEach(element => {            
            if((element.name === 'get')||(element.name === 'list'))
                return ;

            var aplicacao = {};

            aplicacao.valor = element.enumName;
            aplicacao.texto = element.name;

            aplicacaoEnumList.push(aplicacao);
        });

        return aplicacaoEnumList;
    }
}

export default AplicacaoEnum;